/**
 * The portal's answer for a signed-in `client` account the studio hasn't
 * linked to a client yet (403 PORTAL_NOT_LINKED): it won't change until the
 * studio invites the account, so it is shown as a calm message, not retried.
 */

import { PORTAL_NOT_LINKED } from '@nord-living/shared';

import { apiErrorCode } from '@/lib/api-error';

export const isPortalNotLinked = (error: unknown) => apiErrorCode(error) === PORTAL_NOT_LINKED;

/** Retry once like every other query — except the not-linked answer. */
export const retryUnlessNotLinked = (failureCount: number, error: unknown) => !isPortalNotLinked(error) && failureCount < 1;
